function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "currentColor",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.632 14.41c0-.392.127-.712.382-.959.254-.247.57-.371.948-.371s.694.124.949.371c.254.247.381.567.381.96 0 .378-.123.68-.37.904a1.252 1.252 0 01-.873.339 1.58 1.58 0 01-.992-.328c-.283-.218-.425-.523-.425-.915M10.006 4.27c.305 0 .596.12.872.36s.414.527.414.861v5.518c0 .32-.134.585-.403.796-.269.21-.549.316-.84.316-.334 0-.653-.095-.959-.283a.917.917 0 01-.458-.83V5.492c0-.377.145-.676.436-.894.29-.217.603-.327.938-.327",
  fill: "#000"
}));

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAlert;